import script from "./agents-table.windows.vue?vue&type=script&setup=true&lang=ts"
export * from "./agents-table.windows.vue?vue&type=script&setup=true&lang=ts"

import "./agents-table.windows.vue?vue&type=style&index=0&id=bc0bcb0a&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc0bcb0a"]])

export default __exports__